
export const bilansQueryKey = (siren: string) =>
    ['company', 'bilans', siren];

